var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_12745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 0H4.92188C2.20795 0 0 2.20795 0 4.92188V19.0781C0 21.792 2.20795 24 4.92188 24H19.0781C21.792 24 24 21.792 24 19.0781V4.92188C24 2.20795 21.792 0 19.0781 0ZM18.3428 17.3385L17.9662 17.9662C16.5018 19.4307 12.6435 17.9467 9.34838 14.6516C6.05334 11.3566 4.56933 7.49827 6.0338 6.03375L6.66145 5.65716C7.23009 5.316 7.96767 5.50036 8.30883 6.069L9.19748 7.55006C9.48098 8.02252 9.4065 8.62725 9.01692 9.01688C8.46773 9.56606 8.46773 10.4565 9.01692 11.0056L12.9944 14.9831C13.5436 15.5323 14.434 15.5323 14.9831 14.9831C15.3727 14.5935 15.9775 14.519 16.4499 14.8025L17.931 15.6911C18.4996 16.0323 18.684 16.7699 18.3428 17.3385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_12745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIc);
export default __webpack_public_path__ + "static/media/phone_ic.8b0867e5f4ba3ac6abaf1797c79ba44c.svg";
export { ForwardRef as ReactComponent };